import firestore from "../firebase/firestore";

export const saveBankBatch = async (id, url) => {
  return await firestore.doc(`bank_batchs/${id}`).update({ receipt_url: url });
};
